import React from 'react';
import PropTypes from 'prop-types';
import { Slider, FormControl, InputLabel } from '@mui/material';
import styles from './VendorAttribution.module.css';

export default function AttributeSliders(props) {
  const {
    minimum_order_quantity = 0,
    maximum_order_quantity = 10,
    production_lead_time_min = 0,
    production_lead_time_max = 1,
    onChange,
    emptyFields,
    disabled,
  } = props;

  const orderQuantityMarks = [
    {
      value: 1,
      label: '1 unit',
    },
    {
      value: 10000,
      label: '10,000 units',
    },
  ];

  const productionLeadMarks = [
    {
      value: 1,
      label: '1 week',
    },
    {
      value: 30,
      label: '30 weeks',
    },
  ];

  return (
    <div className={styles.sliderContainer}>
      <div>
        <FormControl
          variant="standard"
          required
          className={styles.sliderControl}
          error={!!emptyFields.maximum_order_quantity}
        >
          <InputLabel htmlFor="vatt-slider-moq" className={styles.sliderLabel}>
            Minimum Order Quantity (Units)
          </InputLabel>
          <Slider
            id="vatt-slider-moq"
            value={[minimum_order_quantity || 1, maximum_order_quantity || 1]}
            onChange={(e, newValue) => onChange('moq', newValue)}
            valueLabelDisplay="auto"
            min={1}
            max={10000}
            step={100}
            name="moq"
            marks={orderQuantityMarks}
            disabled={disabled}
          />
        </FormControl>
      </div>
      <div className={styles.slider}>
        <FormControl
          variant="standard"
          required
          className={styles.sliderControl}
          error={!!emptyFields.product_lead_time_max}
        >
          <InputLabel htmlFor="vatt-slider-moq" className={styles.sliderLabel}>
            Production Lead Time (Weeks)
          </InputLabel>
          <Slider
            id="vatt-slider-lead"
            value={[
              production_lead_time_min || 1,
              production_lead_time_max || 1,
            ]}
            onChange={(e, newValue) =>
              onChange('production_lead_time', newValue)
            }
            valueLabelDisplay="auto"
            min={1}
            max={30}
            name="production_lead_time"
            marks={productionLeadMarks}
            disabled={disabled}
          />
        </FormControl>
      </div>
    </div>
  );
}

AttributeSliders.propTypes = {
  onChange: PropTypes.func.isRequired,
  production_lead_time_min: PropTypes.number,
  production_lead_time_max: PropTypes.number,
  minimum_order_quantity: PropTypes.number,
  maximum_order_quantity: PropTypes.number,
  emptyFields: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool,
};
